export default "__VITE_ASSET__e2df0c7b__"